import { Lock, Unlock, Shield } from 'lucide-react'
import type { UnderwritingModel } from '@/types/underwritingModels'

interface Props {
  model: UnderwritingModel
  canUnlock: boolean
  onLock: () => void
  onUnlock: () => void
}

export default function ModelLockBanner({ model, canUnlock, onLock, onUnlock }: Props) {
  if (model.locked) {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-amber-400/20 bg-amber-400/[0.05] px-3 py-2">
        <Lock size={14} className="text-amber-400 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-[11px] text-amber-300">
            Model locked by <span className="font-medium">{model.lockedBy}</span>
            {model.lockedAt && (
              <> on {new Date(model.lockedAt).toLocaleDateString()}</>
            )}
          </span>
          <span className="text-[10px] text-stone-500 ml-2">
            Changes to model structure are prevented.
          </span>
        </div>
        {canUnlock && (
          <button
            onClick={onUnlock}
            className="flex items-center gap-1 rounded border border-amber-400/20 bg-amber-400/10 px-2 py-1 text-[10px] text-amber-300 hover:bg-amber-400/20 transition-colors"
          >
            <Unlock size={10} />
            Unlock
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-stone-700/50 bg-stone-900/30 px-3 py-2">
      <Shield size={14} className="text-stone-500 flex-shrink-0" />
      <span className="flex-1 text-[11px] text-stone-500">
        Model is unlocked. v{model.version} &mdash; Last modified {model.lastModified} by {model.modifiedBy}
      </span>
      <button
        onClick={onLock}
        className="flex items-center gap-1 rounded border border-stone-600/50 bg-stone-800/50 px-2 py-1 text-[10px] text-stone-400 hover:text-amber-300 hover:border-amber-400/20 transition-colors"
      >
        <Lock size={10} />
        Lock Model
      </button>
    </div>
  )
}
